import React from "react";
import savedAnalyses from "../data/private/savedAnalyses.json";
import dashboardData from "../data/private/dashboard.json";

export default function DashboardSavedAnalyses() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-slate-900">
        {dashboardData.savedAnalyses.title}
      </h1>
      <div className="grid gap-4 md:grid-cols-2">
        {savedAnalyses.length === 0 ? (
          <div className="card card-hover p-4">
            <p className="text-sm font-semibold text-slate-900">
              {dashboardData.analyses.title}
            </p>
            <p className="mt-2 text-xs text-slate-500">
              {dashboardData.analyses.ctaLabel}
            </p>
          </div>
        ) : (
          savedAnalyses.map((item) => (
            <div
              key={item.id}
              className="card card-hover p-4"
              title={`${item.title} - ${item.status}`}
            >
              <p className="text-sm font-semibold text-slate-900">
                {item.title}
              </p>
              <p className="mt-2 text-xs text-slate-500">{item.date}</p>
              <p className="mt-1 text-xs text-slate-500">{item.status}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
